export default __webpack_public_path__ + "static/media/art-slt-poster-1.ab24bb92.jpg";